import "animate.css";
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AppRouter } from "./Routers/AppRouter.js";
import "./Styles/fonts.css";
import { ActualizadorContext } from "./actualizadorContext/actualizadorContext.js";
import { AuthContext } from "./auth/authContext";
import { authReducer } from "./auth/authReducer";
import { ConfigurationContext } from "./configuration/configurationContext";
import { configurationReducer } from "./configuration/configurationReducer";


import Cookies from "js-cookie";
import { LoadingProvider } from "./contexts/LoadingContext.js";
import { UpdatedProvider } from "./contexts/UpdateContext.js";
import { VendedoresContratoProvider } from "./contexts/VendedoresContratoContext.js";
import { EstadosContratoProvider } from "./contexts/EstadosContratoContext.js";

const init = () => {
  let hola = Cookies.get(process.env.REACT_APP_COOKIE_NAME);
  if (typeof hola == "undefined") {
    return { logged: false };
  } else {
    return JSON.parse(Cookies.get(process.env.REACT_APP_COOKIE_NAME));
  }
};

const initConfiguration = () => {
  return (
    JSON.parse(localStorage.getItem("configurationVitanova")) || {
      menuAbierto: true,
    }
  );
};

const contadorActualizadorRender = () => {
  return { contadorActualizar: 0 };
};

function App() {
  const [user, dispatch] = React.useReducer(authReducer, {}, init);

  const [actualizarVentanaContext, dispatchActualizarVentanaContext] =
    React.useState(contadorActualizadorRender);

  const [configuration, dispatchConfiguration] = React.useReducer(
    configurationReducer,
    {},
    initConfiguration
  );

  React.useEffect(() => {
    if (!configuration) return;
    localStorage.setItem(
      "configurationVitanova",
      JSON.stringify(configuration)
    );
  }, [configuration]);

  return (
    <React.Fragment>
      <HelmetProvider>
        <VendedoresContratoProvider>
          <UpdatedProvider>
            <LoadingProvider>
              <AuthContext.Provider value={{ user, dispatch }}>
                <ConfigurationContext.Provider
                  value={{ configuration, dispatchConfiguration }}
                >
                  <ActualizadorContext.Provider
                    value={{
                      actualizarVentanaContext,
                      dispatchActualizarVentanaContext,
                    }}
                  >
                    <EstadosContratoProvider>
                      <ToastContainer />
                      <AppRouter />
                    </EstadosContratoProvider>
                  </ActualizadorContext.Provider>
                </ConfigurationContext.Provider>
              </AuthContext.Provider>
            </LoadingProvider>
          </UpdatedProvider>
        </VendedoresContratoProvider>
      </HelmetProvider>
    </React.Fragment>
  );
}

export default App;
